

<app-corporate-header></app-corporate-header>
<div class="container track-details">
  <div class="row">
    <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
      <div class="truck-left">
        <div class="dashboard-menu active">
          <div class="truck-left-icon">
            <img src="assets/img/dashboard.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoToDashboard()">Dashboard</h5>
          </div>
        </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/trip.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoToBookATrips()">Book a Trip</h5>
          </div>
        </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon">

            <img src="assets/img/trp.svg" alt="" />

          </div>
          <div class="truck-left-details">
            <h5 (click)="GoToTrips()">Trips</h5>
          </div>
        </div>
        <div class="dashboard-menu">
            <div class="truck-left-icon">

              <img src="assets/img/wo.svg" alt="" />

            </div>
            <div class="truck-left-details">
              <h5 (click)="GoTOWorkOrders()">Work Orders</h5>
            </div>
          </div>
          <div class="dashboard-menu">
            <div class="truck-left-icon">

              <img src="assets/img/ledg.svg" alt="" />

            </div>
            <div class="truck-left-details">
              <h5 (click)="GoToLedger()">Ledger</h5>
            </div>
          </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/help.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoTOHelp()">Help</h5>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12">
      <div [class.spinner]="loading"></div>

      <div class="row">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
          <div class="dashboard-trips">
            <div class="trips">
              <p>Live Trips</p>
            </div>
            <div class="trips-details">
              <p *ngIf="!dashboard" >{{dashboardArray.liveTrips}}</p>
              <p *ngIf="dashboard">No Trips Found</p>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
          <div class="dashboard-trips">
            <div class="trips">
              <p >Partially Paid</p>
              
            </div>
            <div class="trips-details">
              <p *ngIf="!partially">{{dashboardArray.partiallyPaid}}</p>
              <p *ngIf="partially">No Payment Information</p>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
          <div class="dashboard-trips">
            <div class="trips">
              <p>Trips Expiring Today</p>
            </div>
            <div class="trips-details">
              <p *ngIf="!expiringTrip">{{dashboardArray.tripsExpiry}}</p>
              <p *ngIf="expiringTrip">No Expiring Trips</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

